import { store } from './store'

// XP rules (lightweight, local-only):
// - 10 XP per rep
// - PR bonus: 50 XP for each rep above previous best set in a new session
// Level curve: cumulative XP needed grows linearly per level
//   level 1 -> 0 XP, level 2 -> 200 XP total, then +100 per level step

export function totalXP(): number {
  const sessions = store.all()
  let xp = 0
  let prevBest = 0
  for (const s of sessions) {
    const sessionBest = Math.max(0, ...s.sets.map(se => se.reps))
    const base = s.reps * 10
    const prGain = Math.max(0, sessionBest - prevBest) * 50
    xp += base + prGain
    if (sessionBest > prevBest) prevBest = sessionBest
  }
  return xp
}

export function levelFromXP(xp: number): { level: number; xpInLevel: number; xpToNext: number } {
  let level = 1
  let need = 200
  let remaining = xp
  while (remaining >= need) {
    remaining -= need
    level += 1
    need += 100 // linear growth
  }
  return { level, xpInLevel: remaining, xpToNext: need }
}

export function currentLevel() {
  return levelFromXP(totalXP())
}

export function isNewPR(newBestSet: number): boolean {
  // summarizeWeek returns best set for last 7 days; for PR we want all-time; compute directly from store
  const all = store.all()
  const prevBest = Math.max(0, ...all.flatMap(s => s.sets.map(se => se.reps)))
  return newBestSet > prevBest
}
